import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import {
  ApiResponse,
  Author,
  AuthorDetailApiParams,
  AuthorListApiResponse,
  AuthorResponseItem,
} from '@/shared/types';

const useAuthorQuery = ({ urlIdentifier }: AuthorDetailApiParams) => {
  return useQuery({
    queryKey: ['author', urlIdentifier],
    queryFn: async () => {
      const response = await clientAxios.get<
        ApiResponse<AuthorListApiResponse>
      >('/authorDetailApi/', {
        params: { urlIdentifier },
      });

      const authorData: AuthorResponseItem = response.data.data.results[0];

      const author: Author = {
        id: authorData.id,
        name: authorData.name,
        imageUrl: authorData.image_url,
        isCompany: authorData.is_company,
        count: {
          view: authorData.total_view_count,
          like: authorData.total_like_count,
          scrap: authorData.total_scrap_count,
          subscription: authorData.subscription_count,
          article: authorData.total_news_count,
        },
        urlIdentifier: authorData.author_url_identifier,
        mostPublishedCategory: authorData.most_published_category_list,
        isSubscribed: authorData.is_subscribed,
        description: authorData.description,
        tagLine: authorData.tagline,
        websiteUrl: authorData.website_url,
        employments: authorData.employment.map((emp) => ({
          id: emp.id,
          companyName: emp.company_name,
          isFreelancer: emp.is_freelance,
          workingCompanyName: emp.working_company_name,
          clientName: emp.client_name,
        })),
      };
      return { author };
    },
  });
};

export default useAuthorQuery;
